module.exports = __webpack_public_path__ + "static/ipad-img-1-6421d2952c2fdae923d189860de0bc75.png";